import { render, staticRenderFns } from "./BuyAlert.vue?vue&type=template&id=e2a9c6ee&scoped=true&"
import script from "./BuyAlert.vue?vue&type=script&lang=js&"
export * from "./BuyAlert.vue?vue&type=script&lang=js&"
import style0 from "./BuyAlert.vue?vue&type=style&index=0&id=e2a9c6ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2a9c6ee",
  null
  
)

export default component.exports